
<div>
  <h2 class="mb-4">{{ templateVersion.attribute_store['short-name'] }}</h2>
  <b-card no-body v-if="compatibilityEnabled && compatibility_tags.length > 0" class="mb-2">
    <b-card-header header-bg-variant="secondary" header-text-variant="light">
      <span class="font-weight-bold">Compatibility Filter</span>
    </b-card-header>
    <b-form inline class="p-1">
      <b-container fluid>
        <b-row>
          <b-col v-for="tag in compatibility_tags" :key="tag" cols="6" sm="4" md="4" lg="3" xl="2">
            <b-form-checkbox
                v-model="selected_compatibility_tags[tag]"
                :value="IsSelected.YES"
                :unchecked-value="IsSelected.NO" @change="handleCompatibilityChange(tag,$event)">
              {{tag}}
            </b-form-checkbox>
          </b-col>
        </b-row>
      </b-container>
    </b-form>
  </b-card>
  <b-form>
    <b-card no-body class="mb-1" v-for="category_node in category_nodes" :key="category_node.id">
      <b-card-header header-bg-variant="info" header-text-variant="light">
        <span class="font-weight-bold">{{ category_node.name }}</span>
      </b-card-header>
      <b-table-lite small
                    borderless
                    striped
                    stacked="lg"
                    :fields="generated_fields"
                    :sort-compare="sortFunc"
                    :items="nodes_by_category_node_id[category_node.id]">
        <template v-slot:cell(action)="data">
          <b-form-checkbox
              v-model="data.item.is_selected"
              :value="IsSelected.YES"
              :unchecked-value="IsSelected.NO"
              :disabled="data.item.isDisabled || data.item.isHidden">
          </b-form-checkbox>
        </template>
      </b-table-lite>
    </b-card>
  </b-form>
</div>


